import { buildTrackingUrl, type TrackingContext } from '@apm/contracts';

/**
 * 구매하기 오버레이의 QR 이 가리킬 주소.
 *
 * **추적 파라미터를 반드시 붙인다** (CLAUDE.md 절대 규칙 8). `?src=fast&d=&p=&pl=` 이 있어야
 * "TV 화면에서 본 상품이 실제 구매로 이어졌는가"를 측정할 수 있고, 그것이 이 MVP 가
 * 증명해야 할 사업 지표다.
 *
 * 파라미터 이름을 여기서 다시 쓰지 않고 `@apm/contracts` 의 `buildTrackingUrl` 을 쓴다 —
 * 서버의 랜딩 페이지(`GET /p/{id}`)가 읽는 이름과 같은 출처여야 한다.
 */
export function purchaseQrUrl(deepLink: string, ctx: TrackingContext): string {
  return buildTrackingUrl(deepLink, ctx);
}
